/**
 * created by lei lei on 2020/5/29
 */
import React, {Component} from 'react';
import StaticMyDesk from "./StaticMyDesk";
import StaticMyDeskGw from "./StaticMyDeskGw";
import {connect} from "react-redux";
import $ from 'jquery';

 class PmsStaticMyDesk extends Component {
    static defaultProps = {}
    static propTypes = {}

    constructor(props) {
        super(props);
        this.state={
            isGwFlag:false,
        }
    }

    componentDidMount() {
        if(this.props.sysConfig){
            var isGwConfigParam=this.props.sysConfig.getConfigByKey("pms.mydesk.isGwProject")
            if(isGwConfigParam&&isGwConfigParam.configValue==1){
                this.setState({
                    isGwFlag:true,
                });
            }else{
                this.setState({
                    isGwFlag:false,
                });
            }
        }else{
            this.setState({
                isGwFlag:false,
            });
        }
		
		this.handleAutoOpenFrame();
    }

     componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps.sysConfig){
            var isGwConfigParam=nextProps.sysConfig.getConfigByKey("pms.mydesk.isGwProject")
            if(isGwConfigParam&&isGwConfigParam.configValue==1){
                this.setState({
                    isGwFlag:true,
                })
            }

        }
   }
   
   
    //自动打开弹框
    handleAutoOpenFrame(){
        console.log("===============auto open frame, param is ============",this.props.match.params.type,this.props.match.params.id);
        if(this.props.match.url.indexOf('/view') != 0){
            return;
        }
        let area = [ (window.top.innerWidth*0.9) + 'px',(window.top.innerHeight*0.9) + 'px'];
        let url = "";

        switch(this.props.match.params.type){
            case "story":{
                let storyId = this.props.match.params.id;

                $.post("/cm-sites-pms/storyNew/show", {storyId: storyId}, function (story) {

                    let eiditStoryId = storyId;
                    let actButtonId = 2;
                    let currentMediaCode = story.mediaCode;
                    let treeContentId = 0;
                    let fromZyk="";

                    url = "/cm-sites/pms/addContribute/addContributeNews.html?eiditStoryId=" + eiditStoryId  + '&actButtonId='+actButtonId + '&currentMediaCode='+currentMediaCode +'&treeContentId='+treeContentId+'&fromZyk='+fromZyk;
                    window.top.layer.open({type:2,content:url,area:area})

                },'json');

                break;
            }

            default:return;
        }
    }
   

     render() {
       return this.state.isGwFlag?<StaticMyDeskGw/>:<StaticMyDesk/>;
    }
}

function mapStateToProps(state) {
    return {
        currentUser: state.systemReducer.currentUser,
        sysConfig : state.systemReducer.config,
    }
}

export default connect(mapStateToProps)(PmsStaticMyDesk);

